// extracted by mini-css-extract-plugin
export default {"modal":"modal___ecf0266b2f85ac00","close":"close___ba436be146f5da8d","content":"content___a32e07d96d1946c0"};